import { defineMessages } from 'react-intl';

const messages = defineMessages({
  closeButtonText: {
    id: 'pgn.Modal.closeButon',
    defaultMessage: 'Close',
    description: 'Accessible name for the close button in the modal dialog',
  },
});

export default messages;
